export default function CheckBox({ label, handleCheck, data }) {    
    const isActive = data[label];
    return (
        <div className=" flex items-center select-none first:ml-8" onClick={(label) => handleCheck(label)}>
            <div className={`cursor-pointer !min-w-[16px] !max-w-[16px] h-4 mx-2 border border-solid border-gray-500 rounded ${isActive ? "bg-main-color" : ""}`}></div>
            <label className="cursor-pointer my-1" htmlFor="">{label}</label>
        </div>
    )
}